module.exports = __webpack_public_path__ + "static/media/10-min.94cc5aee.png";